<script lang="ts">
  import { SVG } from "$lib/components";
  import { cn } from "$lib/utility";

  let { logo, sidebar, hamburgerMenuIcon, isInShortcutMode, currentShortcutSequence, isMobile } = $props<{
    logo: string;
    sidebar: any;
    hamburgerMenuIcon: string;
    isInShortcutMode: boolean;
    currentShortcutSequence: string | null;
    isMobile: boolean;
  }>();
</script>

{#if isMobile}
  <!-- Mobile Logo Section -->
  <div class="z-10 flex items-center justify-center gap-2.5 xl:hidden">
    <button
      type="button"
      class="inline-flex items-center justify-center rounded-base p-2 focus:outline-none"
      class:hidden={sidebar.collapsed && sidebar.collapsible === "icon" && !sidebar.isMobile}
      aria-controls="mobile-menu"
      aria-expanded={sidebar?.open ? "true" : "false"}
      onclick={() => {
        sidebar.toggle();
      }}
    >
      <span class="sr-only">Open menu</span>
      <SVG file={hamburgerMenuIcon} className={cn("max-w-9 w-full max-h-9 dark:text-white")} />
    </button>
    <div
      class="z-50 flex flex-shrink-0 items-center"
      class:hidden={sidebar.collapsed && sidebar.collapsible === "icon" && !sidebar.isMobile}
    >
      <div class="flex h-18 items-center justify-between gap-6 font-[18px]">
        <a href="/" class="relative flex items-center gap-2">
          <img src={logo} alt="Logo" class="inline-block h-5" />
          <span
            class="shrink-0 rounded-full border border-green-300 bg-green-200 px-1.5 py-0 text-[9px] text-green-900 dark:border-green-500 dark:bg-green-900 dark:text-green-100"
          >
            ALPHA
          </span>
          {#if isInShortcutMode && !currentShortcutSequence}
            <div
              class="absolute -bottom-4 left-1/2 flex size-6 -translate-x-1/2 translate-y-full items-center justify-center bg-yellow-400 text-black"
            >
              <span class="text-xs">H</span>
            </div>
          {/if}
        </a>
      </div>
    </div>
  </div>
{:else}
  <!-- Desktop Logo Section -->
  <div class={cn("z-50 hidden flex-shrink-0 items-center xl:flex")}>
    <div class="flex h-18 items-center justify-between gap-6 font-[18px]">
      <a href="/" class="relative flex items-center gap-2">
        <img src={logo} alt="Logo" class="inline-block h-5" />
        <span
          class="shrink-0 rounded-full border border-green-300 bg-green-200 px-1.5 py-0 text-[9px] text-green-900 dark:border-green-500 dark:bg-green-900 dark:text-green-100"
        >
          ALPHA
        </span>
        {#if isInShortcutMode && !currentShortcutSequence}
          <div
            class="absolute -bottom-4 left-1/2 flex size-6 -translate-x-1/2 translate-y-full items-center justify-center bg-yellow-400 text-black"
          >
            <span class="text-xs">H</span>
          </div>
        {/if}
      </a>
    </div>
  </div>
{/if}
